import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import LoginForm from './forms/LoginForm';
import { login } from '../actions/index';

var styles = {
  backgroundImage: 'url(' + require('../assets/rmc_background.jpg') + ')'
};

class Login extends Component {
 constructor(props) {
        super(props);
        this.handleLogin = this.handleLogin.bind(this);
 }

 handleLogin(data){
        const { login, history} = this.props;
        login(data);
        history.push("/projects");
 }

  render() {
    const { login } = this.props;
    return (
      <div className="app flex-row align-items-center login" style={styles}>
          <div className="login__wrapper">
            <div className="login__card">
              <div className="login__head">
                <h3 className="login__title">
                  <span className="login__logo"> RMC
                    <span className="login__logo-accent"> AI Service </span>
                     Center
                  </span>
                </h3>
                <h4 className="login__subhead subhead">
                  RMC AI Service Center uses ground breaking technology for MLOps and AI performance management. It also enables auto machine learning model generation for a number of applications
                </h4>
              </div>
              <LoginForm onSubmit={this.handleLogin} />
            </div>
          </div>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    login
  }, dispatch);
}


export default (connect(null, mapDispatchToProps)(Login));



// WEBPACK FOOTER //
// ./src/containers/Login.js